import React from 'react';
import DocumentMeta from 'react-document-meta';

class DocumentMetaTest extends React.Component {
    render() {
        const meta = {
            title: 'Airtiketa',
            description: 'Airtiketa ofron luturime direkte nga Basel, Düsseldorf, Stuttgart, München drejt Prishtinës me çmimet më të mira dhe fluturimet më të rehatshme në treg',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'Airtiketa, Flugtickets nach Prishtina, oferta per fluturime, fluturime drejt prishtine, fluturime kosove, Flugtickets nach Kosovo, flugtickets Prishtina'
                }
            }
        };

        return (
            <DocumentMeta {...meta}>
            </DocumentMeta>
        );
    }
}

export default DocumentMetaTest;